import { Card, CardBody, Col } from "reactstrap";
import { SimpleHorizontalDividerTitle } from "../../../Constants/Constants";
import { SimpleHorizontalDividerData, SimpleHorizontalDividerSubTitle } from "../../../Data/UiKits/Divider";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";

const SimpleHorizontalDivider = () => {
  return (
    <Col md="6">
      <Card>
        <CommonCardHeader title={SimpleHorizontalDividerTitle} span={SimpleHorizontalDividerSubTitle} />
        <CardBody className="main-divider">
          {SimpleHorizontalDividerData.map((item, index) => (
            <div className={`divider-h-line bg-${item}`} key={index}/>
          ))}
        </CardBody>
      </Card>
    </Col>
  );
};

export default SimpleHorizontalDivider;
